'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBinderIndexingMetadata = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var getBinderIndexingMetadata = exports.getBinderIndexingMetadata = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(rootQueryNode, appContext) {
        var walker, binderIndexingMetadata;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        debug('getting binder indexing metadata');
                        walker = new _QueryNodeWalker2.default();
                        binderIndexingMetadata = new _BinderIndexingMetadataVisitor2.default();
                        _context.next = 5;
                        return walker.walk(rootQueryNode, binderIndexingMetadata, appContext);

                    case 5:
                        return _context.abrupt('return', binderIndexingMetadata.indexingMetadata);

                    case 6:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function getBinderIndexingMetadata(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

var _QueryNodeWalker = require('./engine/QueryNodeWalker');

var _QueryNodeWalker2 = _interopRequireDefault(_QueryNodeWalker);

var _BinderIndexingMetadataVisitor = require('./engine/BinderIndexingMetadataVisitor');

var _BinderIndexingMetadataVisitor2 = _interopRequireDefault(_BinderIndexingMetadataVisitor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debug = require('debug')('@complion:query:src:binderIndexingMetadata');